// breadcrumb-labels.constants.ts
export const BreadcrumbLabels = {
    ENTERPRISE_DASHBOARD: 'enterpriseDashboard',
    AGENT_FILES: 'agentFiles',
    SAFE_TRANSACTIONS_BY_SAFE_ID: 'SafeTransactionsBySafeId',
    SAFE_TRANSACTIONS_BY_SAFE_ID_USER: 'SafeTransactionsBySafeIdUser',
    WALLET_BALANCE_SUMMARY: 'walletBalanceSummary',
};
